import React from 'react';
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Stack,
  Text,
  Button,
  Link as ChakraLink,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useDisclosure } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom'; // React Router
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll'; // React Scroll

const links = [
  { name: 'Home', path: '/', hash: '' },
  { name: 'About', path: '/', hash: 'about' },
  { name: 'Passions', path: '/', hash: 'passions' },
];

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation(); // Detect the current route

  const isHomepage = location.pathname === '/';

  const handleHomeClick = () => {
    if (isHomepage) {
      // Scroll to top when on the homepage
      scroll.scrollToTop({ duration: 500, smooth: true });
    } else {
      // Navigate to homepage
      window.location.href = '/';
    }
  };

  return (
    <Box bg="white" px={4} boxShadow="md" position="sticky" top="0" zIndex="10">
      <Flex h={16} alignItems="center" justifyContent="space-between">
        {/* Brand Name */}
        <Text
          fontSize="xl"
          fontWeight="bold"
          color="#afcbff" // pastelBlue color for the brand
          cursor="pointer"
          onClick={handleHomeClick}
        >
          Suzan Cook
        </Text>

        {/* Mobile Menu Icon */}
        <IconButton
          size="md"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Toggle Menu"
          display={{ md: 'none' }}
          onClick={isOpen ? onClose : onOpen}
        />

        {/* Desktop Menu */}
        <HStack as="nav" spacing={4} display={{ base: 'none', md: 'flex' }}>
          {links.map((link) => (
            link.name === 'Home' ? (
              <ChakraLink
                key={link.name}
                onClick={handleHomeClick}
                px={3}
                py={1}
                rounded="md"
                color="#afcbff" // Default pastelBlue color
                _hover={{ bg: 'pastelPink', color: 'white' }} // Hover styles
                _active={{ bg: 'pastelPink', color: 'white' }} // Active styles
                cursor="pointer"
              >
                {link.name}
              </ChakraLink>
            ) : isHomepage ? (
              <ScrollLink
                key={link.name}
                to={link.hash}
                smooth={true}
                duration={500}
                offset={-70}
              >
                <ChakraLink
                  px={3}
                  py={1}
                  rounded="md"
                  color="#afcbff" // Default pastelBlue color
                  _hover={{ bg: 'pastelPink', color: 'white' }}
                  _active={{ bg: 'pastelPink', color: 'white' }}
                  cursor="pointer"
                >
                  {link.name}
                </ChakraLink>
              </ScrollLink>
            ) : (
              <ChakraLink
                key={link.name}
                as={RouterLink}
                to={`${link.path}${link.hash ? `#${link.hash}` : ''}`}
                px={3}
                py={1}
                rounded="md"
                color="#afcbff" // Default pastelBlue color
                _hover={{ bg: 'pastelPink', color: 'white' }}
                _active={{ bg: 'pastelPink', color: 'white' }}
              >
                {link.name}
              </ChakraLink>
            )
          ))}
          {/* Contact Button */}
          <Button
            as={RouterLink}
            to="/contact"
            size="sm"
            bg="pastelGreen"
            color="white"
            _hover={{ bg: 'pastelBlue' }}
          >
            Contact
          </Button>
        </HStack>
      </Flex>

      {/* Mobile Menu */}
      {isOpen && (
        <Box pb={4} display={{ md: 'none' }}>
          <Stack as="nav" spacing={4}>
            {links.map((link) => (
              link.name === 'Home' ? (
                <ChakraLink
                  key={link.name}
                  onClick={() => {
                    handleHomeClick();
                    onClose(); // Close the mobile menu
                  }}
                  px={3}
                  py={1}
                  rounded="md"
                  color="#afcbff" // Default pastelBlue color
                  _hover={{ bg: 'pastelPink', color: 'white' }}
                  _active={{ bg: 'pastelPink', color: 'white' }}
                  cursor="pointer"
                >
                  {link.name}
                </ChakraLink>
              ) : isHomepage ? (
                <ScrollLink
                  key={link.name}
                  to={link.hash}
                  smooth={true}
                  duration={500}
                  offset={-70}
                  onClick={onClose}
                >
                  <ChakraLink
                    px={3}
                    py={1}
                    rounded="md"
                    color="#afcbff" // Default pastelBlue color
                    _hover={{ bg: 'pastelPink', color: 'white' }}
                    _active={{ bg: 'pastelPink', color: 'white' }}
                    cursor="pointer"
                  >
                    {link.name}
                  </ChakraLink>
                </ScrollLink>
              ) : (
                <ChakraLink
                  key={link.name}
                  as={RouterLink}
                  to={`${link.path}${link.hash ? `#${link.hash}` : ''}`}
                  px={3}
                  py={1}
                  rounded="md"
                  color="#afcbff" // Default pastelBlue color
                  _hover={{ bg: 'pastelPink', color: 'white' }}
                  _active={{ bg: 'pastelPink', color: 'white' }}
                  onClick={onClose}
                >
                  {link.name}
                </ChakraLink>
              )
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default Navbar;
